/* global document, alert, FileReader */

import React from 'react'
import PropTypes from 'prop-types'

import FlatButton from 'material-ui/FlatButton'
import parse from 'csv-parse/lib/es5/sync'
import _ from 'lodash'
import * as firebase from 'firebase'
import { connect } from 'react-redux'

import DeleteInvoiceItemDialog from './DeleteInvoiceItemDialog'
import InvoiceItemsList from './InvoiceItemsList'
import withSettingsCard from '../withSettingsCard'
import upload from 'resources/upload_icon.png'

class InvoiceItems extends React.Component {

  static propTypes = {
    style: PropTypes.object,
    teamId: PropTypes.string.isRequired,
    defaultInvoiceItems: PropTypes.object
  }

  constructor(props) {
    super(props)
    this.state = {
      showRemoveAllConfirmation: false
    }
  }

  handleUploadClicked = event => {
    event.preventDefault()
    document.querySelector('input[name=\'invoice-items-upload\']').click()
  }

  handleRemoveAllClicked = event => {
    event.preventDefault()
    this.setState({
      showRemoveAllConfirmation: true
    })
  }

  onFileLoad = e => {
    const updates = {}
    const dbRef = firebase.database().ref(`teams/${this.props.teamId}/defaultInvoiceItems`)
    if (e.target && e.target.result) {
      const records = parse(e.target.result, { columns: true, relax_column_count: true, trim: true })
      for (const record of records) {
        if (record.name) {
          const quantity = parseInt(record.quantity)
          const rate = parseFloat(record.rate)
          const invoiceItem = {
            name: record.name,
            quantity: !isNaN(quantity) ? quantity : null,
            rate: !isNaN(rate) ? rate : null
          }
          const key = dbRef.push().key
          updates[`teams/${this.props.teamId}/defaultInvoiceItems/${key}`] = invoiceItem
        }
      }
    }
    if (_.size(updates)) {
      firebase.database().ref()
        .update(updates)
        .then(() => {
          alert(`Successfully imported ${_.size(updates)} default invoice items.`)
        })
    }
  }

  onFileInputChange = event => {
    const file = event.target.files[0]
    if (file) {
      if (!file.type.match('csv')) {
        alert('Error, expeted CSV file.')
      }
      else {
        const reader = new FileReader()
        reader.onload = this.onFileLoad
        reader.readAsText(file)
      }
    }
  }

  handleDeleteConfirmationResult = result => {
    if (result) {
      firebase.database()
        .ref(`teams/${this.props.teamId}/defaultInvoiceItems`)
        .set(null)
    }
    this.setState({ showRemoveAllConfirmation: false })
  }

  handleDeleteConfirmationCancelled = () => {
    this.setState({ showRemoveAllConfirmation: false })
  }


  render() {
    const count = this.props.defaultInvoiceItems && _.size(this.props.defaultInvoiceItems) || null
    return (
      <div style={{ ...this.props.style, ...styles.container }}>
        <div style={styles.header}>Invoice Items</div>
        <div style={styles.subheader}>Would you like to upload a list of invoice items for easy lookup?</div>
        <div style={styles.actions}>
          <FlatButton
            label='Upload'
            style={styles.actionButton}
            labelStyle={styles.buttonLabel}
            icon={<img src={upload} height={24} width={24} />}
            onTouchTap={this.handleUploadClicked}>
            <input style={{ display: 'none' }} type='file' name='invoice-items-upload' onChange={this.onFileInputChange}
              multiple/>
          </FlatButton>
          { count && <FlatButton
            label='Remove all'
            style={styles.actionButton}
            labelStyle={styles.buttonLabel}
            icon={<i className='material-icons' style={styles.deleteAllIcon}>delete</i>}
            onTouchTap={this.handleRemoveAllClicked}>
          </FlatButton>
          }
        </div>
        <InvoiceItemsList style={styles.list} />
        <DeleteInvoiceItemDialog
          open={this.state.showRemoveAllConfirmation}
          removeAll={true}
          onDialogResult={this.handleDeleteConfirmationResult}
          onRequestClose={this.handleDeleteConfirmationCancelled}/>
      </div>
    )
  }

}

const styles = {
  container: {
    textAlign: 'left',
    paddingTop: 20,
    paddingBottom: 20,
    marginLeft: 24,
    marginRight: 24
  },
  header: {
    fontSize: 18,
    fontWeight: 500,
    marginBottom: 8
  },
  subheader: {
    fontSize: 14,
    fontWeight: 300
  },
  actionButton: {
    borderRadius: 3,
    backgroundColor: '#356992'
  },
  buttonLabel: {
    color: 'white',
    fontSize: 14,
    fontWeight: 400
  },
  list: {
    marginTop: 18
  },
  actions: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginTop: 18
  },
  deleteAllIcon: {
    color: '#fff'
  }
}

const mapStateToProps = state => ({
  teamId: state.firebase.team.metadata.value.id,
  defaultInvoiceItems: state.firebase.team.defaultInvoiceItems.value
})

export default connect(mapStateToProps)(withSettingsCard(InvoiceItems))



// WEBPACK FOOTER //
// ./src/settings/modules/invoiceItems/InvoiceItems.js